import React from "react";

// RENN wordmark logo image
const Logo = ({ className = "", onClick }) => (
  <a
    href="#home"
    onClick={onClick}
    aria-label="Renn home"
    className={`inline-flex items-center select-none ${className}`}
  >
    <img
      src="/renn-logo.png"
      alt="Renn"
      className="h-7 lg:h-8 w-auto"
      draggable={false}
    />
  </a>
);

export default Logo;
